import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useLocation } from "react-router";
import { useSelector, useDispatch } from "react-redux";

// layouts
import { MainLayout } from "layouts";

// components
import { InfoSettingsEditForm } from "components/all/settings";
import { Loading } from "components/common";
import Text from "components/ui/Text";

// redux
import { setGoBackLevel } from "redux/slices/center/centerSettingsSlice";

const InfoSettings = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { partner, partnerBranch } = location.state;
  const { goBackLevel } = useSelector((state) => state.centerSettings);
  const [initialHistoryLength, setInitialHistoryLength] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setInitialHistoryLength(window.history.length);
    dispatch(setGoBackLevel(0));
  }, []);

  return (
    <MainLayout
      withBottomTab={false}
      withHeader={true}
      backgroundColor="white"
      headerProps={{
        withBackButton: true,
        goBackLevel: goBackLevel ? goBackLevel + 1 : 1,
        centerTitle: "센터 정보 설정",
      }}
    >
      {loading && <Loading />}
      <CenterBox>
        <Text
          display="block"
          color="primary100"
          fontSize="14px"
          fontWeight="500"
          lineHeight="18px"
        >
          {partner} {partnerBranch}
        </Text>
      </CenterBox>
      <InfoSettingsEditForm
        info={location.state}
        goBackLevel={goBackLevel}
        setGoBackLevel={(level) => dispatch(setGoBackLevel(level))}
        initialHistoryLength={initialHistoryLength}
        setLoading={setLoading}
      />
    </MainLayout>
  );
};

const CenterBox = styled.div`
  background: #eef5ff;
  border-radius: 6px;
  margin: 12px 20px;
  padding: 12px 0;
  text-align: center;
`;

export default InfoSettings;
